/* eslint-disable func-names */
import * as _ from 'lodash';
import { LANG_CONFIG, LOCALSTORAGE_LANGUAGE } from '../constants/global';
import { customLocalStorage } from './storage';

// tslint:disable
const langMap = {
  cn: 'cn,zh,zh-hans,zh-cn,zh-hans-cn,zh-sg,zh-hans-sg',
  // 简体中文
  tw: 'tw,zh-hant,zh-hk,zh-mo,zh-tw,zh-hant-hk,zh-hant-mo,zh-hant-tw',
  // 繁体中文
  en: 'en,en-au,en-bz,en-ca,en-cb,en-ie,en-jm,en-nz,en-ph,en-za,en-tt,en-gb,en-us,en-zw,en-sg',
  // 英语
  th: 'th,th-th',
  //  傣语
  vi: 'vn,vi-vn,vi,vn-vn',
  //  越南语
  ru: 'ru,ru-ru,ru-mo',
  // 俄语
  id: 'id,id-id,in-id',
  // 印尼语
  ko: 'ko,ko-kr',
  // 朝鲜语
  hi: 'in,hi,hi-in',
  // 印地语
  ar: 'ar,ar-er,ar-sa,ar-eg,ar-dz,ar-tn,ar-ye,ar-jo,ar-kw,ar-bh,ar-iq,ar-ly,ar-ma,ar-om,ar-sy,ar-lb,ar-ae,ar-qa,ar-ss,ar-il',
  // 阿拉伯语
  af: 'af,af-za',
  // 南非语
  tr: 'tr,tr-tr',
  // 土耳其语
  es: 'es,es-ar,es-bo,es-cl,es-co,es-cr,es-do,es-ec,es-es,es-gt,es-hn,es-mx,es-ni,es-pa,es-pe,es-pr,es-py,es-sv,es-uy,es-ve,es-xl,es-us',
  // 西班牙语
  ms: 'ms,ms-bn,ms-my,my',
  // 马来语
  pt: 'pt,pt-pt,pt-br',
  // 葡萄牙语
  ja: 'ja,ja-jp,ja-ja,jp,jp-jp',
  // 日语
  ur: 'ur,ur-pk,ur-in',
  // 乌尔都语
  de: 'de,de-at,de-ch,de-de,de-li,de-lu',
  // 德语
  ne: 'ne,ne-np',
  // 尼泊尔语
  bn: 'bn,bn-bd,bn-in',
  // 孟加拉语
  gu: 'gu,gu-in',
  // 古吉拉特语
  kn: 'kn,kn-in',
  // 埃纳德语
  mr: 'mr,mr-in',
  // 马拉地语
  pa: 'pa,pa-in',
  // 旁遮普语
  ta: 'ta,ta-in',
  // 泰米尔语
  te: 'te,te-in',
  // 泰卢固语
  fil: 'fil,fil-ph',
  // 菲律宾语
  it: 'it,it-ch,it-it',
  // 意大利语
  uk: 'uk,uk-ua',
  // 乌克兰语
  be: 'be,be-by',
  // 白俄罗斯语
  kk: 'kk,kk-kz',
  // 哈萨克语
  fa: 'fa,fa-ir',
  // 波斯语
  da: 'da,da-dk',
  // 丹麦语
  ml: 'ml,ml-in',
  // 马拉雅拉姆语
  or: 'or,or-in',
  // 奥里雅语
  as: 'as,as-in',
  // 阿萨姆语
  ka: 'ka,ka-ge',
  // 格鲁吉亚语
  sa: 'sa,sa-in',
  // 梵语
  uz: 'uz,uz-latn,uz-latn-uz,uz-cyrl,uz-cyrl-uz',
  // 乌兹别克语
  hne: 'hne',
  // 恰蒂斯加尔语
  jv: 'jv',
  // 爪哇语
  raj: 'raj',
  // 拉贾斯坦语
  km: 'km,kh,km-kh,khm',
  // 高棉语
  fr: 'fr,fr-be,fr-ca,fr-fr,fr-lu,fr-mc,fr-ch,fra,fre',
  // 法语
  si: 'si,sin',
  // 僧伽罗语
  pl: 'pl,pol', // 波兰语

  /**
   * @description ISO 3166-1 国家码映射（facebook标准）
   * @see https://zh.wikipedia.org/wiki/ISO_3166-1?fbclid=IwAR1l_8YPkeiFg8S5-n1_iiBq0K4gIBJyBBKGOcCfn16qF5I_hdzDRXEH2nU
   */
};

function getCurrentLocale(conf: any) {
  const defaultConfig = {
    urlLangKey: 'lang',
    defaultLocale: 'en',
    langMap,
    url: window.location.href,
    navigator: window.navigator,
  };
  const config = { ...defaultConfig, ...conf };

  if (config.navigator && !_.isObject(config.navigator)) {
    console.log('i18n getCurrentLocale: navigator is undefined');
    return;
  }

  let userLanguage =
    getParameterByKey(config.url, config.urlLangKey) || config.navigator.language || config.navigator.userLanguage;
  let currentLocale: string | undefined = '';

  if (userLanguage) {
    userLanguage = userLanguage.toLowerCase();
    currentLocale = Object.keys(config.langMap).find(function (key) {
      return config.langMap[key]
        .split(',')
        .map(function (item: string) {
          return item.trim();
        })
        .includes(userLanguage);
    });
  }

  if (!currentLocale) {
    console.log('Cannot find language in lang map, set default locale '.concat(config.defaultLocale));
  }

  // eslint-disable-next-line consistent-return
  return currentLocale || config.defaultLocale;
}

function getParameterByKey(url: string, key: string) {
  const regex = new RegExp('[?&]'.concat(key, '(=([^&#]*)|&|#|$)'));
  const results = regex.exec(url);

  if (!results) {
    return '';
  }

  if (!results[2]) {
    return '';
  }

  return decodeURIComponent(results[2].replace(/\+/g, ' '));
}

export function getCurrentLang() {
  const lang = String(customLocalStorage.getItem(LOCALSTORAGE_LANGUAGE));
  return LANG_CONFIG[lang]
    ? lang
    : getCurrentLocale({
        langMap: {
          en: 'en,en-au,en-bz,en-ca,en-cb,en-ie,en-jm,en-nz,en-ph,en-za,en-tt,en-gb,en-us,en-zw,en-sg',
          // 简体中文
          zh: 'cn,zh,zh-hans,zh-cn,zh-hans-cn,zh-sg,zh-hans-sg',
          // 俄语
          ru: 'ru,ru-ru,ru-mo',
        },
      });
}
